import { useContext, useEffect } from 'react'

import { MODALS_ID } from '../../../constants'

import { StoresContext } from '../../../provider/StoreProvider'
import { ModalContext } from '../../../provider/modalProvider'

import { Content } from '../../../components/container/Content'
import { Header } from '../../../components/header'
import { SettingListContainer } from '../components/SettingListContainer'
import { SettingListContainerProps } from '../components/SettingListContainer'
import { Container } from '../Setting'
import { ConditionsOfServiceTermsModal } from './modals/ConditionsOfServiceTermsModal'
import { PersonalInfoProcessingPolicyTermsModal } from './modals/PersonalInfoProcessingPolicyTermsModal'
// import { PersonalInfoToAThirdPartyModal } from './modals/PersonalInfoToAThirdPartyModal'
// import { PromotionsSuchAsEventsModal } from './modals/PromotionsSuchAsEventsModal'

import { ReactComponent as ArrowGrayIcon } from '../../../assets/ico/common/arrow/right/arrow_right_gray-06_medium.svg'

export function TermsPolicyList() {
  const { commonStore } = useContext(StoresContext)
  const { openModal, closeModal } = useContext(ModalContext)

  const openConditionsOfServiceTermsModal = () => {
    const closeConditionsOfServiceTermsModal = () => closeModal(MODALS_ID.CONDITIONS_OF_SERVICE_TERMS)
    openModal({
      id: MODALS_ID.CONDITIONS_OF_SERVICE_TERMS,
      Component: () => <ConditionsOfServiceTermsModal close={closeConditionsOfServiceTermsModal} />,
    })
  }

  const openPersonalInfoProcessingPolicyTermsModal = () => {
    const closePersonalInfoProcessingPolicyTermsModal = () =>
      closeModal(MODALS_ID.PERSONAL_INFO_PROCESSING_POLICY_TERMS)
    openModal({
      id: MODALS_ID.PERSONAL_INFO_PROCESSING_POLICY_TERMS,
      Component: () => <PersonalInfoProcessingPolicyTermsModal close={closePersonalInfoProcessingPolicyTermsModal} />,
    })
  }

  // const [openPersonalInfoToAThirdPartyModal, closePersonalInfoToAThirdPartyModal] = useIonModal(() => (
  //   <PersonalInfoToAThirdPartyModal close={closePersonalInfoToAThirdPartyModal} />
  // ))

  // const [openPromotionsSuchAsEventsModal, closePromotionsSuchAsEventsModal] = useIonModal(() => (
  //   <PromotionsSuchAsEventsModal close={closePromotionsSuchAsEventsModal} />
  // ))

  useEffect(() => {
    commonStore.setShowTab(false)
  }, [])

  const TERMS: SettingListContainerProps['items'] = [
    {
      isBorder: false,
      list: [
        {
          title: '서비스 이용 약관',
          rightContent: <ArrowGrayIcon />,
          onClick: openConditionsOfServiceTermsModal,
        },
        {
          title: '개인정보 처리 방침',
          rightContent: <ArrowGrayIcon />,
          onClick: openPersonalInfoProcessingPolicyTermsModal,
        },
        // {
        //   title: '개인정보 제 3자 제공 안내',
        //   rightContent: <ArrowGrayIcon />,
        //   onClick: () => openPersonalInfoToAThirdPartyModal(),
        // },
        // {
        //   title: '이벤트 및 혜택 안내',
        //   rightContent: <ArrowGrayIcon />,
        //   onClick: () => openPromotionsSuchAsEventsModal(),
        // },
      ],
    },
  ]

  return (
    <>
      <Header type="SUB" title="약관 및 정책" />
      <Content>
        <Container>
          <SettingListContainer items={TERMS} itemGap={8} />
        </Container>
      </Content>
    </>
  )
}
